module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="row no-gutters">\n  <div class="col-xs-12 col-md-6 fmcy-cart-empty-left-column"></div>\n  <div class="col-xs-12 col-md-6 fmcy-cart-empty-right-column">\n    <div class="fmcy-cart-empty-title">Cart Empty</div>\n    <div class="fmcy-cart-empty-icon"></div>\n  </div>\n</div>\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/cart/cart-empty/cart-empty.html
 ** module id = 852
 ** module chunks = 1 9 154
 **/